import React, { useState } from 'react';

export default function Exchange() {
  const [showModal, setShowModal] = useState(false);
  const [apiKey, setApiKey] = useState('');
  const [apiSecret, setApiSecret] = useState('');

  const handleConnect = (e) => {
    e.preventDefault();
    // TODO: Connect to backend API later
    alert('Connecting to exchange...\nAPI Key: ' + apiKey.substring(0, 5) + '...');
    setShowModal(false);
  };

  return (
    <div className="p-8 text-white flex flex-col items-center justify-center min-h-[70vh]">
      <h1 className="text-3xl font-bold mb-4">Exchange Center</h1>
      <p className="text-gray-400 mb-8">Connect your exchange to start automated trading.</p>

      <button
        onClick={() => setShowModal(true)}
        className="bg-orange-500 hover:bg-orange-600 text-white font-bold py-3 px-8 rounded-lg transition-colors cursor-pointer"
      >
        Connect Exchange
      </button>

      {showModal && (
        <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4">
          <div className="bg-[#161b22] p-6 rounded-2xl w-full max-w-md border border-gray-700 shadow-2xl">
            <h2 className="text-xl font-bold mb-2">Connect Exchange API</h2>
            <p className="text-xs text-gray-400 mb-4">Use Read-Only or Trade-Only permissions. Never use withdrawal access.</p>
            
            <form onSubmit={handleConnect} className="flex flex-col gap-4">
              <div>
                <label className="block text-sm text-gray-400 mb-1">API Key</label>
                <input
                  type="text"
                  value={apiKey}
                  onChange={(e) => setApiKey(e.target.value)}
                  className="w-full bg-[#0d1117] border border-gray-700 rounded-lg px-4 py-2 text-white focus:outline-none focus:border-orange-500"
                  required
                />
              </div>
              <div>
                <label className="block text-sm text-gray-400 mb-1">API Secret</label>
                <input
                  type="password"
                  value={apiSecret}
                  onChange={(e) => setApiSecret(e.target.value)}
                  className="w-full bg-[#0d1117] border border-gray-700 rounded-lg px-4 py-2 text-white focus:outline-none focus:border-orange-500"
                  required
                />
              </div>
              <div className="flex gap-3 mt-2">
                <button
                  type="button"
                  onClick={() => setShowModal(false)}
                  className="flex-1 bg-gray-700 hover:bg-gray-600 text-white font-bold py-2 rounded-lg transition-colors cursor-pointer"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="flex-1 bg-orange-500 hover:bg-orange-600 text-white font-bold py-2 rounded-lg transition-colors cursor-pointer"
                >
                  Connect
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
